const spacing = [
    '0',
    '0125',
    '025',
    '050',
    '0625',
    '075',
    '100',
    '150',
    '200',
    '250',
    '300',
    '350',
    '400',
    '450',
    '500',
    '550',
    '750'
];
export { spacing };

//# sourceMappingURL=tokens.js.map